import { useResponsive } from '@/hooks';
import { ResponsiveCollection } from '@/interfaces';
import { useEffect, useState } from 'react';
import { DesktopOnly, MobileOnly } from './ResponsiveText.styles';

interface ResponsiveTextProps {
  desktopText?: string;
  mobileText?: string;
}

/**
 * Text content with a desktop and a mobile variant, meant to sit inside a single non-heading element (e.g. the banner subtext).
 * Before mount (SSR + hydration) both variants are rendered as spans and CSS shows the right one, so the server
 * HTML has the correct text for every viewport without a layout shift. After mount only the active variant stays
 * in the DOM.
 */
export const ResponsiveText: React.FC<ResponsiveTextProps> = ({ desktopText = '', mobileText = '' }) => {
  const { isDesktop } = useResponsive([ResponsiveCollection.Desktop]);
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  if (desktopText === mobileText) return <>{desktopText}</>;

  if (!hasMounted) {
    return (
      <>
        <DesktopOnly>{desktopText}</DesktopOnly>
        <MobileOnly>{mobileText}</MobileOnly>
      </>
    );
  }

  return <>{isDesktop ? desktopText : mobileText}</>;
};
